/* ==================================================================
   LB Update 56: Produkt-Fenster fuer den Taschen-Knopf auf den Produktkarten.
   Frueher sprang ein Produkt mit mehreren Groessen auf die Produktseite.
   Jetzt oeffnet sich ein Fenster mit Bildergalerie, Titel, Preis (inkl. Sale),
   Varianten zum Wechseln, Groessenauswahl und "In meine Tasche" -
   am Handy von unten, am Desktop mittig.
   Alles steckt in dieser Datei. Faellt das Skript aus, bleibt der bisherige
   Link auf die Produktseite bestehen. Rueckweg: script-Zeile im Kopf entfernen.
   ===================================================================== */
(function(){
  if(window.lbSizeSheetInit)return;window.lbSizeSheetInit=true;
  var D=document,sheet=null,el={},aktuell=null,gewaehlt=null,quelle=null,laeuft=false;
  var cache={},gruppeCache={};
  var anfrage=0; /* LB: nur die zuletzt angestossene Ladeanfrage darf das Fenster fuellen */
  /* LB Update 291 (Auftrag F09/F15): ctrl = AbortController der ausstehenden Produktanfrage, varFehler = die sichtbare
     Meldung ist der Varianten-Ladefehler, offenGen/fokusTimer/schliessTimer = Zeitgeber von Oeffnen/Schliessen. */
  var ctrl=null,varFehler=false,offenGen=0,fokusTimer=0,schliessTimer=0;

  /* LB Update 151: Die Oberflaechentexte dieses Fensters standen fest auf
     Deutsch und erschienen so auch auf /en und /nl. Sprache kommt aus
     window.LBCFG.lang wie in den uebrigen LB-Skripten, Rueckfall ist Deutsch. */
  var LBT=(function(){
    var sprachen={
      de:{schliessen:'Fenster schließen',steuer:'inkl. MwSt. zzgl. Versandkosten',variante:'Variante:',groesse:'Größe',tasche:'In meine Tasche',lager:'Auf Lager – in 1–3 Tagen in deinem Kleiderschrank',rueckgabe:'14 Tage Rückgaberecht',zahlung:'Sicher bezahlen mit Klarna &amp; PayPal',bild:'Bild ',fehlerVariante:'Diese Variante lässt sich gerade nicht laden.',fehlerAdd:'Hinzufügen nicht möglich.',fehlerRetry:'Bitte versuche es erneut.'},
      en:{schliessen:'Close window',steuer:'incl. VAT, plus shipping',variante:'Variant:',groesse:'Size',tasche:'Add to bag',lager:'In stock – in your wardrobe in 1–3 days',rueckgabe:'14-day right of return',zahlung:'Pay securely with Klarna &amp; PayPal',bild:'Image ',fehlerVariante:'This variant cannot be loaded right now.',fehlerAdd:'Could not be added.',fehlerRetry:'Please try again.'},
      nl:{schliessen:'Venster sluiten',steuer:'incl. btw, excl. verzendkosten',variante:'Variant:',groesse:'Maat',tasche:'In mijn tas',lager:'Op voorraad – binnen 1–3 werkdagen in je kast',rueckgabe:'14 dagen herroepingsrecht',zahlung:'Veilig betalen met Klarna &amp; PayPal',bild:'Afbeelding ',fehlerVariante:'Deze variant kan nu niet worden geladen.',fehlerAdd:'Toevoegen niet mogelijk.',fehlerRetry:'Probeer het opnieuw.'},
      fr:{schliessen:'Fermer la fenêtre',steuer:'TVA incluse, frais d’expédition en sus',variante:'Variante :',groesse:'Taille',tasche:'Ajouter au panier',lager:'En stock – livraison en 1–3 jours',rueckgabe:'Droit de retour de 14 jours',zahlung:'Paiement sécurisé avec Klarna &amp; PayPal',bild:'Image ',fehlerVariante:'Cette variante ne peut pas être chargée pour le moment.',fehlerAdd:'Ajout impossible.',fehlerRetry:'Réessaie.'},
      pl:{schliessen:'Zamknij okno',steuer:'z VAT, bez kosztów wysyłki',variante:'Wariant:',groesse:'Rozmiar',tasche:'Dodaj do koszyka',lager:'Dostępne – dostawa w 1–3 dni',rueckgabe:'14 dni na zwrot',zahlung:'Bezpieczna płatność przez Klarna &amp; PayPal',bild:'Obraz ',fehlerVariante:'Nie można teraz załadować tego wariantu.',fehlerAdd:'Nie można dodać produktu.',fehlerRetry:'Spróbuj ponownie.'},
      it:{schliessen:'Chiudi la finestra',steuer:'IVA inclusa, spese di spedizione escluse',variante:'Variante:',groesse:'Taglia',tasche:'Nella mia borsa',lager:'Disponibile – consegna in 1–3 giorni',rueckgabe:'Diritto di reso entro 14 giorni',zahlung:'Paga in sicurezza con Klarna &amp; PayPal',bild:'Immagine ',fehlerVariante:'Al momento non è possibile caricare questa variante.',fehlerAdd:'Impossibile aggiungere l’articolo.',fehlerRetry:'Riprova.'},
      es:{schliessen:'Cerrar ventana',steuer:'IVA incluido, gastos de envío no incluidos',variante:'Variante:',groesse:'Talla',tasche:'Añadir a mi bolsa',lager:'Disponible – entrega en 1–3 días',rueckgabe:'Derecho de devolución de 14 días',zahlung:'Paga de forma segura con Klarna &amp; PayPal',bild:'Imagen ',fehlerVariante:'Esta variante no se puede cargar ahora mismo.',fehlerAdd:'No se puede añadir el artículo.',fehlerRetry:'Inténtalo de nuevo.'}
    };
    var l=((window.LBCFG&&window.LBCFG.lang)||'de').split('-')[0];
    /* LB Update 249 (Lieferzeit, Freigabe Sascha): "in 1-3 Tagen in deinem Kleiderschrank" gilt nur fuer Lieferungen nach
       Deutschland, fuer alle anderen Laender nur die Versanddauer (2-5 Tage, LB Update 289).
       LB Update 292 (Auftrag N-lieferland, I-006; Entscheidung Sascha 04.10.2026: Laendersicht = Versandbalken):
       Massgeblich ist das Land des Versandbalkens, nicht mehr das Serverland beim Laden. Quelle wie in lb-header-tools.js (Schublade):
       window.LBCFG.zielland (setzt lb-cart-tools.js; Startwert = Serverland, danach erkanntes Land; leer = unbekannt), sonst
       LBCFG.country, sonst Shopify.country; unbekannt = Deutschland (1-3). Gelesen wird bei jedem Oeffnen und bei 'lb:country'. */
    var t=sprachen[l]||sprachen.de;
    var sk=sprachen[l]?l:'de';
    var zielLand=function(){
      var c='';
      try{var L=window.LBCFG;c=L&&typeof L.zielland==='string'?L.zielland:String((L&&L.country)||(window.Shopify&&window.Shopify.country)||'');}catch(e){}
      c=String(c).toUpperCase();
      return /^[A-Z]{2}$/.test(c)?c:'';
    };
    t.lagerDE=t.lager;
    /* LB Update 289 (Vorgaben Inhaber 01.10.2026): Lieferzeit ausserhalb Deutschlands 2-5 Tage (wie lb.stock.in_stock_abroad). */
    t.lagerAB=({de:'Auf Lager – Lieferung in 2–5 Tagen',en:'In stock – delivery in 2–5 days',nl:'Op voorraad – levering binnen 2–5 werkdagen',fr:'En stock – livraison en 2–5 jours',pl:'Dostępne – dostawa w 2–5 dni',it:'Disponibile – consegna in 2–5 giorni',es:'Disponible – entrega en 2–5 días'})[sk];
    t.lagerText=function(){var c=zielLand();return (!c||c==='DE')?t.lagerDE:t.lagerAB;};
    t.lager=t.lagerText();
    t.aus=({de:'ausverkauft',en:'sold out',nl:'uitverkocht',fr:'épuisé',pl:'wyprzedane',it:'esaurito',es:'agotado'})[sprachen[l]?l:'de'];
    return t;
  })();

  var CSS=''
  +'.lb-sheet[hidden]{display:none!important}'
  +'.lb-sheet{position:fixed;inset:0;z-index:1000000;display:flex;align-items:flex-end;justify-content:center}'
  +'.lb-sheet__backdrop{position:absolute;inset:0;background:rgba(33,29,25,.45);opacity:0;transition:opacity .22s ease}'
  +'.lb-sheet.is-open .lb-sheet__backdrop{opacity:1}'
  +'.lb-sheet__panel{position:relative;width:100%;max-width:640px;max-height:92vh;overflow-y:auto;-webkit-overflow-scrolling:touch;background:#fff;border-radius:24px 24px 0 0;padding:10px 16px calc(18px + env(safe-area-inset-bottom,0px));box-shadow:0 -10px 40px rgba(33,29,25,.18);transform:translateY(100%);transition:transform .26s cubic-bezier(.22,.8,.3,1);color:#211d19;font-family:var(--typeBasePrimary),Poppins,sans-serif;text-align:left}'
  +'.lb-sheet.is-open .lb-sheet__panel{transform:translateY(0)}'
  +'.lb-sheet__grip{width:42px;height:4px;margin:0 auto 10px;border-radius:999px;background:#e5d9cb}'
  +'.lb-sheet__close{position:absolute;top:10px;right:12px;z-index:3;width:36px;height:36px;display:flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:50%;background:#fff;color:#211d19;box-shadow:0 1px 6px rgba(33,29,25,.16);cursor:pointer}'
  +'.lb-sheet__close:hover{background:#faf6f0}'
  /* Galerie */
  +'.lb-sheet__gallery{display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;margin:0 0 8px;padding:0}'
  +'.lb-sheet__gallery::-webkit-scrollbar{display:none}'
  +'.lb-sheet__slide{flex:0 0 72%;scroll-snap-align:center;border-radius:16px;overflow:hidden;background:#faf6f0;line-height:0}'
  +'.lb-sheet__slide img{display:block;width:100%;aspect-ratio:3/4;object-fit:cover}'
  /* Nur ein Bild: mittig statt linksbuendig */
  +'.lb-sheet__gallery--einzel{justify-content:center}'
  +'.lb-sheet__dots{display:flex;justify-content:center;gap:6px;margin:0 0 14px}'
  +'.lb-sheet__dot{width:6px;height:6px;padding:0;border:0;border-radius:50%;background:#ddd4c8;cursor:pointer}'
  +'.lb-sheet__dot[aria-current="true"]{background:#211d19}'
  /* Kopf */
  +'.lb-sheet__title{display:block;margin:0 0 8px;font-size:19px;line-height:1.3;font-weight:700;color:#211d19;text-decoration:none}'
  +'.lb-sheet__title:hover{text-decoration:underline}'
  +'.lb-sheet__price{font-size:20px;line-height:1.25;display:flex;flex-wrap:wrap;align-items:baseline;gap:8px}'
  +'.lb-sheet__price s{color:#6b6259;font-size:15px;font-weight:400}'
  +'.lb-sheet__price strong{font-weight:700}'
  +'.lb-sheet__sale{color:#067f11}'
  +'.lb-sheet__percent{padding:3px 9px;border-radius:999px;background:#e8f4e9;color:#067f11;font-size:13px;font-weight:700}'
  +'.lb-sheet__tax{margin:4px 0 16px;font-size:12px;line-height:1.4;color:#6b6259}'
  /* Varianten */
  +'.lb-sheet__varblock{margin:0 0 16px}'
  +'.lb-sheet__varhead{display:flex;flex-wrap:wrap;align-items:baseline;gap:6px;margin:0 0 10px;font-size:13px;color:#6b6259}'
  +'.lb-sheet__varname{font-weight:600;color:#211d19}'
  +'.lb-sheet__vars{display:flex;flex-wrap:wrap;gap:12px}'
  +'.lb-sheet__var{width:50px;height:50px;padding:0;border:0;border-radius:50%;overflow:hidden;background:#faf6f0;cursor:pointer;box-shadow:0 0 0 1px #e5d9cb;line-height:0}'
  +'.lb-sheet__var img{width:100%;height:100%;object-fit:cover;display:block}'
  +'.lb-sheet__var[aria-current="true"]{box-shadow:0 0 0 2px #211d19}'
  /* Groessen */
  +'.lb-sheet__sizelabel{margin:0 0 8px;font-size:13px;font-weight:600;color:#211d19}'
  +'.lb-sheet__sizes{display:grid;grid-template-columns:repeat(auto-fill,minmax(88px,1fr));gap:10px;margin-bottom:16px}'
  +'.lb-sheet__size{min-height:46px;padding:10px 12px;border:1px solid #e5d9cb;border-radius:999px;background:#fff;color:#211d19;font-size:14px;font-weight:500;line-height:1.2;cursor:pointer;font-family:inherit}'
  +'.lb-sheet__size:hover:not([disabled]){border-color:#211d19}'
  +'.lb-sheet__size[aria-pressed="true"]{background:#211d19;border-color:#211d19;color:#fff}'
  +'.lb-sheet__size[disabled]{color:#b0a79c;border-color:#efe8df;text-decoration:line-through;cursor:not-allowed}'
  +'.lb-sheet__note:not([hidden]){margin:0 0 12px;padding:10px 12px;border-radius:12px;background:#faf6f0;font-size:13px;line-height:1.4}'
  +'.lb-sheet__note[data-fehler="true"]{background:#fdecec;color:#a4201b}'
  +'.lb-sheet__add{width:100%;min-height:48px;padding:11px 20px;border:0;border-radius:50px;background:#068a13;color:#fff;font-family:inherit;font-size:13px;font-weight:700;line-height:1.42;letter-spacing:2.6px;text-transform:uppercase;cursor:pointer}'
  +'.lb-sheet__add:hover:not([disabled]){background:#057010}'
  +'.lb-sheet__add[disabled]{opacity:.45;cursor:not-allowed}'
  +'.lb-sheet__stock{display:flex;align-items:center;gap:8px;margin:12px 0 0;font-size:14px;line-height:1.4;color:#067f11}'
  +'.lb-sheet__stock:before{content:"";width:9px;height:9px;border-radius:50%;background:#067f11;flex:0 0 9px}'
  +'.lb-sheet__trust{display:flex;flex-wrap:nowrap;align-items:center;justify-content:center;gap:5px;margin:10px 0 0;font-size:11px;line-height:1.4;color:#514435}'
  +'.lb-sheet__trust span+span:before{content:"|";display:inline-block;margin-right:5px;color:currentColor}'
  +'.lb-sheet__panel :focus-visible{outline:2px solid #211d19;outline-offset:2px}'
  +'.lb-sheet [hidden]{display:none!important}'
  +'html.lb-sheet-offen,html.lb-sheet-offen body{overflow:hidden!important;overscroll-behavior:none}'
  +'@media(min-width:769px){.lb-sheet{align-items:center}'
  +'.lb-sheet__panel{max-width:520px;border-radius:24px;padding:16px 22px 22px;transform:translateY(16px) scale(.98);opacity:0;transition:transform .2s ease,opacity .2s ease;box-shadow:0 24px 60px rgba(33,29,25,.22)}'
  +'.lb-sheet.is-open .lb-sheet__panel{transform:none;opacity:1}'
  +'.lb-sheet__grip{display:none}.lb-sheet__slide{flex:0 0 58%}}'
  +'@media(prefers-reduced-motion:reduce){.lb-sheet__panel,.lb-sheet__backdrop{transition:none!important}}';

  var HTML=''
  +'<div class="lb-sheet__backdrop" data-lb-sheet-close></div>'
  +'<div class="lb-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="LbSheetTitle">'
  +'<button type="button" class="lb-sheet__close" data-lb-sheet-close aria-label="'+LBT.schliessen+'">'
  +'<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
  +'<div class="lb-sheet__grip" aria-hidden="true"></div>'
  +'<div class="lb-sheet__gallery" data-galerie></div>'
  +'<div class="lb-sheet__dots" data-punkte></div>'
  +'<a class="lb-sheet__title" id="LbSheetTitle" href="#"></a>'
  +'<div class="lb-sheet__price" data-preis></div>'
  +'<p class="lb-sheet__tax">'+LBT.steuer+'</p>'
  +'<div class="lb-sheet__varblock" data-varblock hidden>'
  +'<div class="lb-sheet__varhead"><span>'+LBT.variante+'</span><span class="lb-sheet__varname" data-varname></span></div>'
  +'<div class="lb-sheet__vars" data-vars></div></div>'
  +'<div class="lb-sheet__sizelabel" data-groessenlabel>'+LBT.groesse+'</div>'
  +'<div class="lb-sheet__sizes" data-groessen></div>'
  +'<p class="lb-sheet__note" role="status" hidden data-note></p>'
  +'<button type="button" class="lb-sheet__add" data-add disabled>'+LBT.tasche+'</button>'
  +'<p class="lb-sheet__stock" data-lager hidden>'+LBT.lager+'</p>'
  +'<p class="lb-sheet__trust"><span>'+LBT.rueckgabe+'</span><span>'+LBT.zahlung+'</span></p>'
  +'</div>';

  function wurzel(){var r=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';return r.replace(/\/$/,'');}
  function geld(c){try{if(window.theme&&theme.Currency&&theme.Currency.formatMoney&&theme.settings&&theme.settings.moneyFormat)return theme.Currency.formatMoney(Number(c),theme.settings.moneyFormat);}catch(e){}var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';var loc={EUR:'de-DE',PLN:'pl-PL',CZK:'cs-CZ',DKK:'da-DK',SEK:'sv-SE',HUF:'hu-HU',RON:'ro-RO'};try{return new Intl.NumberFormat(loc[cur]||'de-DE',{style:'currency',currency:cur}).format(Number(c)/100);}catch(e2){}return (Number(c)/100).toFixed(2).replace('.',',')+' '+cur;}
  /* Sichtbare Galeriebilder: gleiche CDN-Adresse und Revision wie die Karte,
     passende Pixelbreite und Vorladen erst bei einer konkreten Kaufabsicht. */
  var galerieHinweise={},galerieVorschau={},galerieWarm={},galerieWarmReihenfolge=[];
  function bildUrl(u,w){
    try{
      var url=new URL(String(u),window.location.href);
      var datei=url.pathname.match(/^\/s\/files\/1\/0585\/7371\/7549\/files\/(.+)$/);
      if(url.hostname==='cdn.shopify.com'&&datei){
        url=new URL('/cdn/shop/files/'+datei[1],window.location.origin);
        var original=new URL(String(u),window.location.href);
        original.searchParams.forEach(function(v,k){url.searchParams.set(k,v);});
      }
      url.searchParams.set('width',w);return url.href;
    }catch(e){return String(u).split('?')[0]+'?width='+w;}
  }
  function galerieSchluessel(u){
    try{var x=new URL(String(u),window.location.href);return x.pathname.split('/').pop()+'|'+(x.searchParams.get('v')||'');}
    catch(e){return String(u);}
  }
  function galerieBedarf(){
    var vw=window.innerWidth||390;
    var css=vw>=769?(Math.min(vw,520)-44)*.58:(Math.min(vw,640)-32)*.72;
    return Math.min(1080,Math.ceil(css*Math.max(1,window.devicePixelRatio||1)));
  }
  function galerieBreite(){
    var ziel=galerieBedarf(),stufen=[360,540,720,900,1080];
    for(var i=0;i<stufen.length;i++)if(stufen[i]>=ziel)return stufen[i];
    return 1080;
  }
  function galerieUrl(u){return galerieHinweise[galerieSchluessel(u)]||bildUrl(u,galerieBreite());}
  function galerieVorladung(u,i){
    if(!u||galerieWarm[u])return;
    var im=new Image();im.loading='eager';im.decoding='async';im.setAttribute('fetchpriority',i?'auto':'high');
    galerieWarm[u]=im;galerieWarmReihenfolge.push(u);im.src=u;
    if(galerieWarmReihenfolge.length>48)delete galerieWarm[galerieWarmReihenfolge.shift()];
  }
  function kartenBilder(btn){
    var karte=btn&&btn.closest('.grid-product,.lb-wk__karte');
    if(!karte)return;
    var bilder=karte.querySelectorAll('.grid-product__image-mask img,.lb-wk__bild img');
    for(var i=0;i<Math.min(bilder.length,2);i++){
      var im=bilder[i],roh=im.currentSrc||im.getAttribute('src');
      if(!roh||roh.indexOf('data:')===0)continue;
      var url=bildUrl(roh,galerieBreite()),geladen=im.currentSrc;
      /* Ein bereits geladenes Kartenbild reicht oft auch fuer das Fenster.
         Kein zweiter Download, wenn seine Aufloesung die Galerie abdeckt. */
      var breite=im.naturalWidth;
      try{breite=Number(new URL(geladen,window.location.href).searchParams.get('width'))||breite;}catch(e){}
      if(im.complete&&breite>=galerieBedarf()&&geladen)url=geladen;
      if(im.complete&&im.naturalWidth>0&&geladen)galerieVorschau[galerieSchluessel(roh)]=geladen;
      galerieHinweise[galerieSchluessel(roh)]=url;
      galerieVorladung(url,i);
    }
    /* Das zweite Kartenbild wird mobil noch nicht als img eingebaut. */
    var hover=karte.querySelector('[data-lb-hover]');
    if(hover){
      var roh2=hover.getAttribute('data-lb-hover');
      if(roh2){var url2=bildUrl(roh2,galerieBreite());galerieHinweise[galerieSchluessel(roh2)]=url2;galerieVorladung(url2,1);}
    }
  }
  function kaufAbsicht(e){
    var b=e.target&&e.target.closest&&e.target.closest('[data-lb-sheet],a.lb-quick-buy__toggle');
    if(b)kartenBilder(b);
  }
  D.addEventListener('pointerover',kaufAbsicht,{passive:true});
  D.addEventListener('pointerdown',kaufAbsicht,{passive:true});
  D.addEventListener('focusin',kaufAbsicht);
  function basisName(t){return String(t||'').split(/\s[–-]\s/)[0].trim();}

  function bauen(){
    if(sheet)return;
    var st=D.createElement('style');st.setAttribute('data-lb','size-sheet');st.textContent=CSS;D.head.appendChild(st);
    sheet=D.createElement('div');sheet.className='lb-sheet';sheet.id='LbSizeSheet';sheet.hidden=true;sheet.innerHTML=HTML;
    D.body.appendChild(sheet);
    el.panel=sheet.querySelector('.lb-sheet__panel');
    el.galerie=sheet.querySelector('[data-galerie]');el.punkte=sheet.querySelector('[data-punkte]');
    el.titel=sheet.querySelector('.lb-sheet__title');el.preis=sheet.querySelector('[data-preis]');
    el.varblock=sheet.querySelector('[data-varblock]');el.varname=sheet.querySelector('[data-varname]');
    el.vars=sheet.querySelector('[data-vars]');el.groessenlabel=sheet.querySelector('[data-groessenlabel]');
    el.groessen=sheet.querySelector('[data-groessen]');el.note=sheet.querySelector('[data-note]');
    el.add=sheet.querySelector('[data-add]');el.lager=sheet.querySelector('[data-lager]');
    sheet.addEventListener('click',function(e){if(e.target.closest('[data-lb-sheet-close]'))schliessen();});
    el.add.addEventListener('click',inTasche);
    el.galerie.addEventListener('scroll',punkteAktualisieren,{passive:true});
    /* LB Update 291 (Auftrag F15): trapPanel haengt jetzt am document statt am Panel, damit auch ein Tab bei verlorenem
       Fokus (BODY, z. B. nach dem Neuaufbau) ins offene Fenster zurueckfuehrt und nicht auf den Skip-Link dahinter springt. */
    D.addEventListener('keydown',trapPanel);
  }

  /* LB Update 291 (Auftrag F15): Fokusfalle des Groessenfensters (gemeinsame Fokusfunktion, siehe F13 theme.a11y.trapFocus:
     beide arbeiten nur im jeweils offenen Fenster und stoeren sich nicht). Nur aktiv, solange das Fenster offen ist (is-open),
     nicht waehrend des Ausblendens - dann kann bereits der Warenkorb offen sein. */
  function trapPanel(e){
    if(e.key!=='Tab'||!sheet||sheet.hidden||!sheet.classList.contains('is-open'))return;
    var f=[].filter.call(el.panel.querySelectorAll('button:not([disabled]),a[href]'),function(x){return x.offsetParent!==null;});
    if(!f.length)return;
    var erst=f[0],letzt=f[f.length-1],a=D.activeElement;
    /* Fokus verloren (BODY): zurueck ins Fenster. Liegt der Fokus auf einem Element ausserhalb (z. B. ein anderer, darueber
       geoeffneter Dialog), bleibt er dort - diese Falle greift nur im eigenen Panel. */
    if(!a||a===D.body||a===D.documentElement){e.preventDefault();(e.shiftKey?letzt:erst).focus();return;}
    if(!el.panel.contains(a))return;
    if(e.shiftKey&&a===erst){e.preventDefault();letzt.focus();}
    else if(!e.shiftKey&&a===letzt){e.preventDefault();erst.focus();}
  }

  /* LB Update 291 (Auftrag F09): Jede Auswahlabsicht (Farbwechsel, Wiederwahl der angezeigten Farbe, Oeffnen, Schliessen)
     ist eine neue Generation: die ausstehende Produktanfrage wird abgebrochen und ihre Antwort ungueltig gemacht;
     eine zu dem alten Wechsel gehoerende Fehlermeldung verschwindet. */
  function neueAbsicht(){
    anfrage++;
    if(ctrl){try{ctrl.abort();}catch(e){}ctrl=null;}
    if(varFehler&&sheet)zeigeNote('');
    return anfrage;
  }
  function neuesSignal(){
    ctrl=(typeof AbortController==='function')?new AbortController():null;
    return ctrl?ctrl.signal:undefined;
  }

  /* LB Update 291 (Auftrag F15): Fokus nach dem Neuaufbau. Liegt der Fokus in einem neu aufgebauten Bereich (Farbpunkte,
     Groessen, Galerie) oder ausserhalb des Fensters (BODY nach entferntem Knopf), wird ein vorhandenes Element im
     offenen Panel fokussiert: bevorzugt der neue aktuelle Farbknopf, sonst die erste freie Groesse, der Knopf
     "In meine Tasche" oder zuletzt "Schliessen". */
  function fokusVerloren(){
    var a=D.activeElement;
    if(!a||a===D.body||a===D.documentElement||!el.panel.contains(a))return true;
    return el.vars.contains(a)||el.groessen.contains(a)||el.galerie.contains(a)||el.punkte.contains(a);
  }
  function fokusSetzen(bevorzugt){
    var q=function(sel){return el.panel.querySelector(sel);};
    var z=(bevorzugt==='farbe')?q('.lb-sheet__var[aria-current="true"]'):null;
    z=z||q('.lb-sheet__size:not([disabled])')||q('.lb-sheet__var[aria-current="true"]')||(el.add.disabled?null:el.add)||q('.lb-sheet__close');
    if(!z)return;
    try{z.focus({preventScroll:true});}catch(e){try{z.focus();}catch(e2){}}
  }

  function zeigeNote(text,fehler){
    varFehler=false;
    if(!text){el.note.hidden=true;el.note.removeAttribute('data-fehler');return;}
    el.note.textContent=text;el.note.hidden=false;
    if(fehler)el.note.setAttribute('data-fehler','true');else el.note.removeAttribute('data-fehler');
  }

  function punkteAktualisieren(){
    var k=el.galerie.children,n=el.punkte.children.length;
    if(!n||!k.length)return;
    var mitte=el.galerie.scrollLeft+el.galerie.clientWidth/2,i=0,best=1e9;
    for(var j=0;j<k.length;j++){var b=k[j].offsetLeft+k[j].offsetWidth/2,d=Math.abs(b-mitte);if(d<best){best=d;i=j;}}
    for(var m=0;m<n;m++)el.punkte.children[m].setAttribute('aria-current',m===i?'true':'false');
  }

  function galerieBauen(p){
    el.galerie.innerHTML='';el.punkte.innerHTML='';
    var bilder=(p.images&&p.images.length?p.images:(p.featured_image?[p.featured_image]:[])).slice(0,6);
    if(!bilder.length){el.galerie.hidden=true;el.punkte.hidden=true;return;}
    el.galerie.hidden=false;el.punkte.hidden=bilder.length<2;
    if(el.galerie.classList.toggle){el.galerie.classList.toggle('lb-sheet__gallery--einzel',bilder.length===1);}
    bilder.forEach(function(src,i){
      var d=D.createElement('div');d.className='lb-sheet__slide';
      var im=D.createElement('img');im.alt=p.title+(i?' – '+LBT.bild+(i+1):'');
      im.loading=i<2?'eager':'lazy';im.decoding='async';
      im.setAttribute('fetchpriority',i?'auto':'high');
      var ziel=galerieUrl(src),vorschau=galerieVorschau[galerieSchluessel(src)];
      /* Das bereits sichtbare Kartenfoto bleibt sofort verfuegbar, waehrend
         die passende Retina-Aufloesung im Hintergrund geladen wird. */
      if(i<2&&vorschau&&vorschau!==ziel){
        galerieVorladung(ziel,i);var hoch=galerieWarm[ziel];
        if(hoch.complete&&hoch.naturalWidth){im.src=ziel;}
        else{im.src=vorschau;hoch.addEventListener('load',function(){if(im.isConnected)im.src=ziel;},{once:true});}
      }else{im.src=ziel;}
      d.appendChild(im);el.galerie.appendChild(d);
      if(bilder.length>1){
        var pt=D.createElement('button');pt.type='button';pt.className='lb-sheet__dot';
        pt.setAttribute('aria-label',LBT.bild+(i+1));pt.setAttribute('aria-current',i?'false':'true');
        pt.addEventListener('click',function(){el.galerie.scrollTo({left:d.offsetLeft-(el.galerie.clientWidth-d.offsetWidth)/2,behavior:'smooth'});});
        el.punkte.appendChild(pt);
      }
    });
    el.galerie.scrollLeft=0;
  }

  function preisAnzeigen(v){
    var p=v?v.price:aktuell.price,cmp=v?v.compare_at_price:aktuell.compare_at_price;
    el.preis.innerHTML='';
    if(cmp&&cmp>p){
      var s=D.createElement('s');s.textContent=geld(cmp);
      var st=D.createElement('strong');st.className='lb-sheet__sale';st.textContent=geld(p);
      var pr=D.createElement('span');pr.className='lb-sheet__percent';pr.textContent='−'+Math.round((cmp-p)*100/cmp)+'%';
      el.preis.appendChild(s);el.preis.appendChild(st);el.preis.appendChild(pr);
    }else{var st2=D.createElement('strong');st2.textContent=geld(p);el.preis.appendChild(st2);}
  }

  function waehle(btn,v){
    var k=el.groessen.children;for(var i=0;i<k.length;i++)k[i].setAttribute('aria-pressed','false');
    btn.setAttribute('aria-pressed','true');gewaehlt=v;el.add.disabled=false;preisAnzeigen(v);zeigeNote('');
    el.lager.hidden=!v.available;
  }

  /* Geschwister-Produkte ueber den Titel finden: "Flower Jacket - Creme" -> "Flower Jacket" */
  function varianten(p){
    el.varblock.hidden=true;el.vars.innerHTML='';
    var basis=basisName(p.title);
    if(!basis||basis===p.title.trim())return;
    el.varname.textContent=p.title;
    var zeige=function(liste){
      /* LB Update 291 (Audit S2-030): Kam die Antwort erst, nachdem das Fenster schon ein anderes Produkt zeigt
         (schneller Wechsel, langsames Netz), wird sie verworfen - sonst stuenden Farbpunkte des vorigen Produkts im neuen Fenster. */
      if(aktuell!==p)return;
      var treffer=liste.filter(function(x){return basisName(x.title)===basis;});
      if(treffer.length<2)return;
      var hatteFokus=el.vars.contains(D.activeElement);
      el.vars.innerHTML='';
      treffer.forEach(function(x){
        var b=D.createElement('button');b.type='button';b.className='lb-sheet__var';
        b.setAttribute('aria-label',x.title);b.setAttribute('title',x.title);
        b.setAttribute('aria-current',x.handle===aktuell.handle?'true':'false');
        var im=D.createElement('img');im.src=x.bild?bildUrl(x.bild,120):'';im.alt='';im.loading='lazy';
        b.appendChild(im);
        /* LB Update 291 (Auftrag F09): auch die angezeigte Farbe bekommt den Handler - ihre Wiederwahl ist eine neue
           Auswahlabsicht und invalidiert einen ausstehenden Wechsel auf eine andere Farbe (siehe wechsle). */
        b.addEventListener('click',function(){if(x.bild)galerieVorladung(galerieUrl(x.bild),0);wechsle(x.handle);});
        el.vars.appendChild(b);
      });
      el.varblock.hidden=false;
      if(hatteFokus)fokusSetzen('farbe');
    };
    if(gruppeCache[basis]){zeige(gruppeCache[basis]);return;}
    /* Eigene Suchansicht (templates/search.lbgroup.liquid) statt suggest.json:
       liefert bis zu 50 Treffer als schlanke Liste, dadurch werden die
       Farbvarianten zuverlaessig gefunden. */
    fetch(wurzel()+'/search?view=lbgroup&type=product&options%5Bprefix%5D=last&q='+encodeURIComponent(basis),{credentials:'same-origin'})
      .then(function(r){return r.ok?r.text():null;})
      .then(function(txt){
        var liste=[];
        try{ liste=(JSON.parse(String(txt).trim())||[]).map(function(x){return {title:x.t,handle:x.h,bild:x.i||'',verfuegbar:x.a};}); }catch(e){}
        /* LB Update 291 (Audit S2-030): Fehler/leere Antwort nicht merken, sonst bleiben die Farben bis zum Neuladen weg. */
        if(liste.length)gruppeCache[basis]=liste;
        zeige(liste);
      }).catch(function(){});
  }

  /* LB Update 58: Welche Auswahl ist die Groesse?
     Viele Produkte haben zwei Optionen (z. B. Farbe UND Groesse), aber die Farbe hat
     nur einen Wert ("Beige / S", "Beige / M", ...). Frueher sind solche Produkte auf
     die Produktseite gesprungen. Jetzt gilt: Hat genau eine Auswahl mehrere Werte,
     ist das die Groesse und das Fenster oeffnet. Erst bei zwei echten Auswahlen
     (z. B. mehrere Farben UND mehrere Groessen) geht es weiter auf die Produktseite. */
  function groessenAchse(p){
    if(!p||!p.variants||!p.variants.length)return null;
    var opts=p.options||[];
    var anzahl=opts.length||1;
    var achsen=[];
    for(var i=0;i<anzahl;i++){
      var roh=opts[i];
      var name=(typeof roh==='string')?roh:((roh&&roh.name)||LBT.groesse);
      var werte=[];
      for(var k=0;k<p.variants.length;k++){
        var w=p.variants[k]['option'+(i+1)];
        if(w&&werte.indexOf(w)<0)werte.push(w);
      }
      achsen.push({i:i,name:name,anzahl:werte.length});
    }
    var mehr=achsen.filter(function(a){return a.anzahl>1;});
    if(mehr.length>1)return null;
    return mehr.length?mehr[0]:achsen[achsen.length-1];
  }

  function aufbauen(p){
    aktuell=p;gewaehlt=null;el.add.disabled=true;zeigeNote('');el.lager.hidden=true;
    var url=wurzel()+'/products/'+p.handle;
    el.titel.textContent=p.title;el.titel.href=url;
    galerieBauen(p);preisAnzeigen(null);
    var achse=groessenAchse(p)||{i:0,name:LBT.groesse};
    el.groessenlabel.textContent=achse.name;
    el.groessen.innerHTML='';
    var frei=[];
    p.variants.forEach(function(v){
      var b=D.createElement('button');b.type='button';b.className='lb-sheet__size';
      b.textContent=String(v['option'+(achse.i+1)]||v.title||'').trim()||v.title;
      b.setAttribute('aria-pressed','false');
      if(!v.available){b.disabled=true;b.setAttribute('title',LBT.aus);}
      else{frei.push({b:b,v:v});b.addEventListener('click',function(){waehle(b,v);});}
      el.groessen.appendChild(b);
    });
    if(frei.length===1)waehle(frei[0].b,frei[0].v);
    varianten(p);
  }

  function wechsle(handle){
    /* LB Update 291 (Auftrag F09): Wiederwahl der gerade angezeigten Farbe = neue Absicht ohne Neuaufbau: ein ausstehender
       Wechsel auf eine andere Farbe wird abgebrochen und verworfen, Groessenauswahl und Fokus bleiben unberuehrt. */
    if(aktuell&&aktuell.handle===handle){neueAbsicht();return;}
    var nr=neueAbsicht();
    /* LB Update 291 (Auftrag F15): nur die aktuelle Generation baut auf und setzt den Fokus; Fehler und Schliessen
       (anfrage++) fassen den Fokus nicht an. */
    var zeige=function(p){var muss=fokusVerloren();aufbauen(p);el.panel.scrollTop=0;if(muss)fokusSetzen('farbe');};
    if(cache[handle]){zeige(cache[handle]);return;}
    fetch(wurzel()+'/products/'+handle+'.js',{credentials:'same-origin',signal:neuesSignal()})
      .then(function(r){if(!r.ok)throw new Error('http '+r.status);return r.json();})
      .then(function(p){if(!p)throw new Error('leer');cache[handle]=p;if(nr!==anfrage)return;zeige(p);})
      .catch(function(){if(nr===anfrage){zeigeNote(LBT.fehlerVariante,true);varFehler=true;}});
  }

  /* LB Update 292 (Auftrag N-lieferland, I-006): Lieferzeit-Zeile folgt dem Land des Versandbalkens (beim Oeffnen und bei Landwechsel). */
  function lagerAktualisieren(){
    if(!sheet||!el.lager)return;
    var tx=LBT.lagerText();
    if(el.lager.textContent!==tx)el.lager.textContent=tx;
  }

  function oeffnen(){
    /* LB Update 291 (Auftrag F15/F09): ein noch ausstehendes Ausblenden eines frueher geschlossenen Fensters darf das
       neu geoeffnete nicht nachtraeglich verstecken (Timer in schliessen); der verzoegerte Erstfokus gilt nur, solange
       dieses Oeffnen noch aktuell ist - Schliessen innerhalb der 80 ms zieht den Fokus nicht mehr ins Fenster. */
    clearTimeout(schliessTimer);clearTimeout(fokusTimer);
    var g=++offenGen;
    lagerAktualisieren();
    sheet.hidden=false;D.documentElement.classList.add('lb-sheet-offen');
    requestAnimationFrame(function(){if(offenGen===g)sheet.classList.add('is-open');});
    fokusTimer=setTimeout(function(){if(offenGen===g)fokusSetzen('groesse');},80);
  }

  function schliessen(){
    neueAbsicht();
    if(!sheet)return;
    offenGen++;clearTimeout(fokusTimer);
    sheet.classList.remove('is-open');
    clearTimeout(schliessTimer);
    schliessTimer=setTimeout(function(){sheet.hidden=true;D.documentElement.classList.remove('lb-sheet-offen');},220);
    if(quelle){try{quelle.focus();}catch(e){}quelle=null;}
  }

  function inTasche(){
    if(!gewaehlt||laeuft)return;
    laeuft=true;el.add.disabled=true;zeigeNote('');
    fetch(wurzel()+'/cart/add.js',{method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{id:Number(gewaehlt.id),quantity:1}]})})
    /* LB Update 291 (Audit S2-014): HTML-/Nicht-JSON-Antwort (z. B. 429/5xx) -> Standardmeldung statt 'Unexpected token <'; Shopify-JSON mit description bleibt unveraendert */
    .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};},function(){return {ok:false,d:null};});})
    .then(function(res){
      if(!res.ok||!res.d)throw new Error(res.d&&typeof res.d.description==='string'?res.d.description:LBT.fehlerAdd);
      schliessen();
      D.dispatchEvent(new CustomEvent('cart:build'));
      D.dispatchEvent(new CustomEvent('cart:open'));
    })
    .catch(function(e){zeigeNote(e.message||LBT.fehlerRetry,true);})
    .then(function(){laeuft=false;el.add.disabled=!gewaehlt;});
  }

  window.lbSizeSheetOeffnen=function(handle,btn){
    var zur=wurzel()+'/products/'+handle;
    var nr=neueAbsicht();
    quelle=btn||null;kartenBilder(btn);
    var fertig=function(p){
      if(!p||!p.variants||!p.variants.length||!groessenAchse(p)){window.location.href=zur;return;}
      bauen();aufbauen(p);oeffnen();
    };
    if(cache[handle]){fertig(cache[handle]);return;}
    /* LB Update 59: Bremst Shopify die Anfrage kurz aus (Antwort 429), wurde frueher
       sofort auf die Produktseite gesprungen. Jetzt wird einmal nachgefasst. */
    var sig=neuesSignal();
    var hole=function(versuch){
      return fetch(zur+'.js',{credentials:'same-origin',signal:sig})
        .then(function(r){if(!r.ok)throw new Error('http '+r.status);return r.json();})
        .catch(function(e){
          /* LB Update 291 (Auftrag F09): nur nachfassen, solange diese Absicht noch aktuell ist (kein Nachfassen nach Abbruch) */
          if(versuch<1&&nr===anfrage)return new Promise(function(f){setTimeout(f,700);}).then(function(){return nr===anfrage?hole(versuch+1):null;});
          throw e;
        });
    };
    hole(0)
      .then(function(p){if(p)cache[handle]=p;if(nr!==anfrage)return;fertig(p);})
      .catch(function(){if(nr===anfrage)window.location.href=zur;});
  };

  /* Absichtlich auf window und in der Erfassungsphase: so greift es vor dem
     alten Schnellkauf-Handler, der auf document liegt. */
  window.addEventListener('click',function(e){
    if(!e.target||!e.target.closest)return;
    var b=e.target.closest('[data-lb-sheet]');
    var handle=b?b.getAttribute('data-lb-sheet'):null;
    if(!b){
      var a=e.target.closest('a.lb-quick-buy__toggle');
      if(!a)return;
      var m=String(a.getAttribute('href')||'').split('?')[0].split('#')[0].match(/\/products\/([^\/]+)\/?$/);
      if(!m)return;
      b=a;handle=decodeURIComponent(m[1]);
    }
    if(!handle)return;
    e.preventDefault();e.stopImmediatePropagation();
    window.lbSizeSheetOeffnen(handle,b);
  },true);

  /* LB Update 291 (Auftrag I-001): Escape schliesst das Groessenblatt nicht, solange ein Dialog (z. B. Newsletter-Popup) darueber aktiv ist;
     den Escape bearbeitet dann nur der Dialog (Fokus bleibt nicht auf BODY haengen). */
  D.addEventListener('keydown',function(e){if(e.key==='Escape'&&sheet&&!sheet.hidden&&!D.querySelector('.modal--is-active'))schliessen();});

  /* LB Update 292 (Auftrag N-lieferland, I-006): Landwechsel des Versandbalkens (Ereignis von lb-cart-tools.js) bei offenem Fenster uebernehmen. */
  D.addEventListener('lb:country',lagerAktualisieren);
})();
